/* ============================================================
   47X · V6.2.1 · CAPA COMERCIAL (ofr47)
   1) banners de oferta por sección  2) barra comercial dinámica
   3) popup con cupo de sesión
   IntersectionObserver · sin polling · sin librerías · sin requests.
   Eventos por window.Ev47 (namespace 47x:).
   ============================================================ */
(function () {
  'use strict';
  if (window.__ofr47) return;
  window.__ofr47 = 1;

  /* ═══════ 0 · CTA PRINCIPAL ANIMADO ═══════
     El CTA late para pedir el clic y se calma al tocarlo, SOLO en la vista
     actual. Nada de sessionStorage: eso lo dejaba quieto para siempre en la
     pestaña y se leía como bug (medido: 0 cambios en 5 s).

     bfcache · la trampa de volver con BACK
     ─────────────────────────────────────
     Safari/iOS (y Chrome) guardan la página viva al navegar y la devuelven
     TAL CUAL con back: mismo DOM, misma memoria, sin re-ejecutar este script.
     Como tocar el CTA es justamente lo que lleva a la ficha, el visitante
     volvía a un botón que ya traía puesta la clase `is-calm` — y encima sin
     su disparador, porque era {once:true} y ya se había gastado. Resultado:
     quieto para siempre y ni un segundo toque lo revivía.
     Por eso el estado del CTA se REARMA en `pageshow` cuando `persisted` es
     true. Solo el CTA: ni recarga, ni reinicio de componentes, ni se toca la
     navegación back. */
  (function () {
    var MOD = /^cta47a--/;

    function calma() {
      var todos = document.querySelectorAll('.cta47a');
      for (var k = 0; k < todos.length; k++) todos[k].classList.add('is-calm');
    }

    /* Vuelve a dejar el CTA insistente y con su disparador listo.
       `reinicia` solo en bfcache: WebKit puede devolver la animación
       congelada en el fotograma donde quedó, así que se le quitan y se le
       reponen los modificadores (--pulse / --bounce) con un reflow del
       propio botón en medio. Cuesta un reflow puntual, no por frame. */
    function arma(reinicia) {
      var ctas = document.querySelectorAll('.cta47a');
      for (var i = 0; i < ctas.length; i++) {
        var el = ctas[i];
        el.classList.remove('is-calm');

        /* Misma función + mismas opciones: el navegador no duplica el
           listener. Y con {once:true} el anterior ya se quitó al dispararse. */
        el.removeEventListener('pointerdown', calma);
        el.addEventListener('pointerdown', calma, { once: true });

        if (!reinicia) continue;
        var mods = [];
        for (var c = 0; c < el.classList.length; c++) {
          if (MOD.test(el.classList[c])) mods.push(el.classList[c]);
        }
        if (!mods.length) continue;
        for (var m = 0; m < mods.length; m++) el.classList.remove(mods[m]);
        void el.offsetWidth;
        for (var n = 0; n < mods.length; n++) el.classList.add(mods[n]);
      }
    }

    if (document.querySelectorAll('.cta47a').length) arma(false);

    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) arma(true);
    });
  })();

  var raiz = document.querySelector('[data-ofr47]');
  if (!raiz) return;

  function pub(nombre, datos) {
    try { if (window.Ev47 && window.Ev47.pub) window.Ev47.pub(nombre, datos || {}); } catch (e) {}
  }
  function leeSS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ponSS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ═══════ 1 · BANNERS ═══════
     Ya fueron reubicados por el script inline de la sección.
     Aquí solo: impresión (una vez) y clic. */
  var banners = [].slice.call(document.querySelectorAll('[data-ofr47-banner]'));

  if (banners.length && 'IntersectionObserver' in window) {
    var ioBan = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        if (!ents[i].isIntersecting) continue;
        var el = ents[i].target;
        pub('section_offer_viewed', {
          oferta: el.getAttribute('data-ofr47-id') || '',
          seccion: el.getAttribute('data-ofr47-ancla') || ''
        });
        ioBan.unobserve(el);
      }
    }, { threshold: 0.5 });
    banners.forEach(function (b) { ioBan.observe(b); });
  }

  banners.forEach(function (b) {
    b.addEventListener('click', function () {
      pub('section_offer_clicked', {
        oferta: b.getAttribute('data-ofr47-id') || '',
        seccion: b.getAttribute('data-ofr47-ancla') || '',
        destino: b.getAttribute('href') || ''
      });
    });
  });

  /* ═══════ 1a · CARRUSELES DE UNA HILERA ═══════
     Sirve a cualquier .mysx47__marco (Mystery en el hero, filas de Studios).
     Sin librerías: scrollBy y una comprobación de topes. */
  (function () {
    var marcos = document.querySelectorAll('.mysx47__marco');
    for (var m = 0; m < marcos.length; m++) monta(marcos[m]);

    function monta(marco) {
      var riel = marco.querySelector('[data-mysx47-riel]');
      var navs = marco.querySelectorAll('[data-mysx47]');
      if (!riel || !navs.length) return;

      function paso() {
        var card = riel.firstElementChild;
        var ancho = card ? card.getBoundingClientRect().width : 240;
        return Math.round((ancho + 12) * 2);          /* dos cards por clic */
      }
      function refresca() {
        var hay = riel.scrollWidth > riel.clientWidth + 4;
        for (var i = 0; i < navs.length; i++) {
          var dir = Number(navs[i].getAttribute('data-mysx47'));
          var tope = dir < 0
            ? riel.scrollLeft <= 2
            : riel.scrollLeft >= riel.scrollWidth - riel.clientWidth - 2;
          navs[i].hidden = !hay || tope;
        }
      }
      for (var i = 0; i < navs.length; i++) {
        navs[i].addEventListener('click', function () {
          riel.scrollBy({ left: paso() * Number(this.getAttribute('data-mysx47')), behavior: 'smooth' });
        });
      }
      riel.addEventListener('scroll', function () {
        clearTimeout(riel.__t); riel.__t = setTimeout(refresca, 90);
      }, { passive: true });
      window.addEventListener('resize', function () {
        clearTimeout(marco.__rz); marco.__rz = setTimeout(refresca, 180);
      }, { passive: true });
      refresca();
      setTimeout(refresca, 900);                       /* tras cargar imágenes */
    }
  })();

  /* ═══════ 1b · MENSAJES ROTATIVOS ═══════
     Un intervalo por banner, y solo mientras está en pantalla: al salir
     del viewport se detiene, así no gasta nada en el resto del scroll. */
  (function () {
    var cajas = document.querySelectorAll('[data-ofr47-rota]');
    if (!cajas.length || !('IntersectionObserver' in window)) return;

    var PAUSA = 2400;   /* 1 s más rápido que antes */
    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var c = ents[i].target;
        if (ents[i].isIntersecting) arranca(c); else para(c);
      }
    }, { threshold: 0.35 });

    function arranca(c) {
      if (c.__t) return;
      var msgs = (c.getAttribute('data-ofr47-rota') || '').split('|');
      var limpios = [];
      for (var i = 0; i < msgs.length; i++) {
        var m = msgs[i].replace(/^\s+|\s+$/g, '');
        if (m) limpios.push(m);
      }
      if (limpios.length < 2) return;
      var n = 0, dentro = c.firstElementChild;
      c.__t = setInterval(function () {
        n = (n + 1) % limpios.length;
        c.classList.add('is-fuera');
        setTimeout(function () {
          if (dentro) dentro.textContent = limpios[n];
          c.classList.remove('is-fuera');
        }, 340);
      }, PAUSA);
    }
    function para(c) { if (c.__t) { clearInterval(c.__t); c.__t = null; } }

    for (var i = 0; i < cajas.length; i++) io.observe(cajas[i]);
  })();

  /* ═══════ 1c · BANNER ROTATIVO ═══════
     Un mensaje a la vez. Sale hacia arriba, se cambia el texto y el nuevo
     entra desde abajo. Solo corre mientras está en pantalla. */
  (function () {
    var rots = document.querySelectorAll('[data-ofr47-rotador]');
    if (!rots.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var r = ents[i].target;
        if (ents[i].isIntersecting) arranca(r); else para(r);
      }
    }, { threshold: 0.3 });

    function arranca(r) {
      if (r.__rt) return;
      var crudos = (r.getAttribute('data-ofr47-rotador') || '').split('|');
      var msgs = [];
      for (var i = 0; i < crudos.length; i++) {
        var m = crudos[i].replace(/^\s+|\s+$/g, '');
        if (m) msgs.push(m);
      }
      if (msgs.length < 2) return;

      var cada = (parseFloat(r.getAttribute('data-ofr47-ms')) || 4) * 1000;
      var caja = r.querySelector('.rot47__msg');
      var n = r.__n || 0;

      if (!r.__visto) {
        r.__visto = 1;
        try {
          if (window.Ev47 && window.Ev47.pub) {
            window.Ev47.pub('section_offer_viewed', {
              oferta: r.getAttribute('data-ofr47-id') || '',
              seccion: r.getAttribute('data-ofr47-ancla') || '',
              tipo: 'rotador'
            });
          }
        } catch (e) {}
      }

      r.__rt = setInterval(function () {
        n = (n + 1) % msgs.length;
        r.__n = n;
        r.classList.add('is-fuera');                 /* sale hacia arriba */
        setTimeout(function () {
          if (caja) caja.textContent = msgs[n];
          r.classList.remove('is-fuera');
          r.classList.add('is-entra');               /* se coloca abajo, sin transición */
          if (window.requestAnimationFrame) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { r.classList.remove('is-entra'); });
            });
          } else {
            setTimeout(function () { r.classList.remove('is-entra'); }, 20);
          }
        }, 340);
      }, cada);
    }
    function para(r) { if (r.__rt) { clearInterval(r.__rt); r.__rt = null; } }

    for (var i = 0; i < rots.length; i++) {
      io.observe(rots[i]);
      if (rots[i].tagName === 'A') {
        rots[i].addEventListener('click', function () {
          try {
            if (window.Ev47 && window.Ev47.pub) {
              window.Ev47.pub('section_offer_clicked', {
                oferta: this.getAttribute('data-ofr47-id') || '',
                destino: this.getAttribute('href') || '', tipo: 'rotador'
              });
            }
          } catch (e) {}
        });
      }
    }
  })();

  /* ═══════ 2 · BARRA COMERCIAL DINÁMICA ═══════ */
  var barra = document.querySelector('[data-ofr47-bar]');
  if (barra && banners.length && 'IntersectionObserver' in window) {
    var textoEl = barra.querySelector('[data-ofr47-bar-t]');
    var linkEl  = barra.querySelector('a') || barra;
    var actual  = null;

    /* Mide, sin tocar nada del tema:
       --ofr47-safe : alto de la barra de envío gratis (fixed abajo en mobile)
       --ofr47-hueco: ancho que ocupan los botones flotantes de la esquina
                      inferior derecha (WhatsApp, asistente, coach). */
    var FLOTANTES = '.wa47, .asis47__launch, .asis47__bot, [class*="coach47"], [id*="coach-fam47"]';

    function visibleFijo(el) {
      if (!el) return false;
      var cs = getComputedStyle(el);
      return cs.position === 'fixed' && cs.display !== 'none' &&
             cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
    }

    function calcHuecos() {
      var benv = document.querySelector('.benv47');
      var alto = visibleFijo(benv) ? (benv.offsetHeight || 0) : 0;
      document.documentElement.style.setProperty('--ofr47-safe', alto + 'px');

      var hueco = 18, w = window.innerWidth;
      var flot = document.querySelectorAll(FLOTANTES);
      for (var i = 0; i < flot.length; i++) {
        if (!visibleFijo(flot[i])) continue;
        var r = flot[i].getBoundingClientRect();
        if (!r.width || r.left < w * 0.5) continue;   /* solo los de la derecha */
        var necesita = w - r.left + 22;
        if (necesita > hueco) hueco = necesita;
      }
      document.documentElement.style.setProperty('--ofr47-hueco', Math.round(hueco) + 'px');
    }
    calcHuecos();
    window.addEventListener('resize', function () {
      clearTimeout(window.__ofr47rz);
      window.__ofr47rz = setTimeout(calcHuecos, 180);
    }, { passive: true });
    /* los flotantes montan tarde: una sola remedición diferida, sin polling */
    setTimeout(calcHuecos, 2500);

    function pinta(b) {
      if (!b || actual === b) return;
      actual = b;
      var t = b.getAttribute('data-ofr47-bar-texto') || b.getAttribute('data-ofr47-t') || '';
      if (textoEl) textoEl.textContent = t;
      linkEl.setAttribute('href', b.getAttribute('href') || '#');
      linkEl.setAttribute('data-ofr47-id', b.getAttribute('data-ofr47-id') || '');
      barra.classList.add('is-on');
    }
    function apaga() { barra.classList.remove('is-on'); actual = null; }

    /* La barra sigue a la oferta ACTIVA = el último banner que ya cruzó la
       línea de disparo (55% del viewport). Se observan los banners y no las
       secciones: el wrapper de sección puede medir 0px de alto (h61_uni) y
       entonces casi nunca intersecta. Una vez pasada la primera oferta la
       barra se queda encendida y solo cambia de contenido. */
    function recalcula() {
      var act = null;
      for (var i = 0; i < banners.length; i++) if (banners[i].__ofr47pasado) act = banners[i];
      if (act) pinta(act); else apaga();
    }

    var LINEA = 0.55;   /* línea de disparo: 55% del alto de la pantalla */

    var ioBar = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var e = ents[i];
        /* el root está recortado por arriba hasta la línea, así que "ya pasó"
           se mide contra ESA línea y no contra el borde del viewport */
        var linea = (e.rootBounds && typeof e.rootBounds.top === 'number')
          ? e.rootBounds.top
          : window.innerHeight * LINEA;
        e.target.__ofr47pasado = e.isIntersecting || e.boundingClientRect.top < linea;
      }
      recalcula();
    }, { rootMargin: '-55% 0px 0px 0px', threshold: 0 });

    banners.forEach(function (b) { ioBar.observe(b); });

    linkEl.addEventListener('click', function () {
      pub('promo_bar_clicked', {
        oferta: linkEl.getAttribute('data-ofr47-id') || '',
        destino: linkEl.getAttribute('href') || ''
      });
    });
  }

  /* ═══════ 3 · POPUP ═══════ */
  var pop = document.querySelector('[data-ofr47-pop]');
  if (pop) {
    var CUPO   = parseInt(pop.getAttribute('data-ofr47-cupo') || '2', 10);
    var ESPERA = parseInt(pop.getAttribute('data-ofr47-espera') || '12', 10) * 1000;
    var SCROLL = parseInt(pop.getAttribute('data-ofr47-scroll') || '35', 10);
    var KEY_N  = 'ofr47:popups';
    var KEY_1  = 'ofr47:pop:' + (pop.getAttribute('data-ofr47-pop') || 'x');
    var card   = pop.querySelector('.ofr47pop__card');
    var abierto = false, armado = false, t0 = Date.now();

    function mostrados() { return parseInt(leeSS(KEY_N) || '0', 10); }

    function puede() {
      if (abierto) return false;
      if (leeSS(KEY_1) === '1') return false;          /* este popup ya salió */
      if (mostrados() >= CUPO) return false;           /* cupo de sesión */
      if (window.__pop47lock) return false;            /* otro modal abierto ahora */
      return true;
    }

    function abre(motivo) {
      if (!puede()) return;
      abierto = true;
      try { window.__pop47lock = 1; } catch (e) {}
      ponSS(KEY_1, '1');
      ponSS(KEY_N, String(mostrados() + 1));
      pop.classList.add('is-on');
      pop.removeAttribute('aria-hidden');
      var b = pop.querySelector('.ofr47pop__cta'); if (b) b.focus();
      pub('popup_viewed', { popup: pop.getAttribute('data-ofr47-pop'), motivo: motivo });
      desarma();
    }

    function cierra(via) {
      if (!abierto) return;
      abierto = false;
      try { window.__pop47lock = 0; } catch (e) {}
      if (window.pop47Release) { try { window.pop47Release(); } catch (e) {} }
      pop.classList.remove('is-on');
      pop.setAttribute('aria-hidden', 'true');
      pub('popup_closed', { popup: pop.getAttribute('data-ofr47-pop'), via: via });
    }

    /* disparadores de intención real */
    function porScroll() {
      if (Date.now() - t0 < ESPERA) return;
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      if ((h.scrollTop || document.body.scrollTop) / max * 100 >= SCROLL) abre('scroll');
    }
    function porSalida(e) {
      if (Date.now() - t0 < ESPERA) return;
      if (e.clientY <= 0) abre('exit');
    }
    function arma() {
      if (armado) return; armado = true;
      window.addEventListener('scroll', porScroll, { passive: true });
      document.addEventListener('mouseout', porSalida);
    }
    function desarma() {
      window.removeEventListener('scroll', porScroll);
      document.removeEventListener('mouseout', porSalida);
      armado = false;
    }
    if (mostrados() < CUPO && leeSS(KEY_1) !== '1') setTimeout(arma, ESPERA);

    var cta = pop.querySelector('.ofr47pop__cta');
    if (cta) cta.addEventListener('click', function () {
      pub('popup_clicked', { popup: pop.getAttribute('data-ofr47-pop'), destino: cta.getAttribute('href') || '' });
      abierto = false;
      try { window.__pop47lock = 0; } catch (e) {}
    });

    [].slice.call(pop.querySelectorAll('[data-ofr47-cerrar]')).forEach(function (x) {
      x.addEventListener('click', function () { cierra(x.getAttribute('data-ofr47-cerrar') || 'boton'); });
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) cierra('fondo'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) cierra('esc'); });
    if (card) card.addEventListener('click', function (e) { e.stopPropagation(); });
  }
})();
